<mat-dialog-content class="p-0">
    <p class="text-2xl mb-4">Configuração do PDF</p>
    <fieldset class="fieldset-style">
        <legend class="legend-style">Despesas</legend>
        <mat-radio-group aria-labelledby="group-label" class="radio-group" [(ngModel)]="selectedOption">
            <mat-radio-button class="mat-radio-button" [value]="1">
                Agrupar e somar
            </mat-radio-button>
            <mat-radio-button class="mat-radio-button" [value]="2">
                Listar por categoria
            </mat-radio-button>
            <mat-radio-button class="mat-radio-button" [value]="3">
                Exibir todas sem agrupar
            </mat-radio-button>
        </mat-radio-group>
    </fieldset>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <fieldset class="fieldset-style">
            <legend class="legend-style">Donativos</legend>
            <mat-checkbox
                (ngModelChange)="onCheckboxChange(1, $event)"
                [ngModel]="selectedOptions.includes(1)">
                Mostrar detalhes
            </mat-checkbox>
        </fieldset>
        <fieldset class="fieldset-style">
            <legend class="legend-style">Patrocinadores</legend>
            <mat-checkbox
                (ngModelChange)="onCheckboxChange(2, $event)"
                [ngModel]="selectedOptions.includes(2)">
                Mostrar detalhes
            </mat-checkbox>
        </fieldset>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-stroked-button [mat-dialog-close]="false">Cancelar</button>
    <button mat-flat-button [color]="'primary'" (click)="confirmSelection()">Ok</button>
</mat-dialog-actions>
